export const DEFAULT_DEBOUNCE_TIME = 300;
export const DEFAULT_MIN_CHARACTERS = 2;
export const DEBOUNCE_VARIANT_DARK = 'dark';
export const DEBOUNCE_VARIANT_LIGHT = 'light';

export type DebounceInputVariant = typeof DEBOUNCE_VARIANT_LIGHT | typeof DEBOUNCE_VARIANT_DARK;

export interface DebouncedInputSearchProps {
  disabled?: boolean;
  readOnly?: boolean;
  onChange: (value: string) => void;
  debounceTime?: number;
  hasError?: boolean;
  placeholder?: string;
  defaultValue?: string;
  className?: string;
  paddingClasses?: string;
  shadowed?: boolean;
  canDeleteSearch?: boolean;
  minCharacters?: number;
  placeholderColor?: string;
  variant?: DebounceInputVariant;
}
